<template>
  <div>
    <div class="ui zw align-content-center">
      <img width="100px" class="ui image" :src="successImage" alt="Success">

      <h1 class="header">{{ $t('globals.checkout.success.title') }}</h1>
      <div class="ui divider"></div>

      <div class="success-block">
        <p>{{ $t('globals.checkout.success.text', {0: getContainerName}) }}</p>

        <a href="#" class="ui blue button" @click.prevent="handleRedirect">{{ $t('globals.checkout.success.button_text') }}</a>
      </div>
    </div>

    <template v-if="isLocalEnv">
      <loading :active.sync="isLoading"
               :is-full-page="fullPage"/>
    </template>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import successImage from '../../../assets/images/payment/success-icon.png'

export default {
  name: 'VippsSuccess',

  data () {
    return {
      container: null,
      containerId: null,
      isIntro: false,
      isLoading: false,
      fullPage: true
    }
  },

  components: {
    Loading
  },

  mounted () {
    let queryParams = this.$route.query

    if (!queryParams.container) {
      this.$router.push('/dashboard')
    } else {
      this.container = queryParams.container
      this.containerId = queryParams.containerId

      if (queryParams.intro) {
        this.isIntro = true
      }
    }
  },

  methods: {
    handleRedirect() {
      if (this.container === 'booked') {
        this.$router.push({name: 'bookings'})
      } else {
        this.redirect(this.container, this.containerId)
      }
    },

    redirect (container, id) {
      if (this.isIntro) {
        this.$router.push({name: 'setupsuccess'})
      } else {
        if (container === 'subscriptions') {
          this.$router.push({name: 'subscriptiondashboard', params: { subscriptionId: id }},
            () => {
              this.$router.go()
            }
          )
        } else {
          this.$router.push({name: 'wait_list'},
            () => {
              this.$router.go()
            }
          )
        }
      }
    }
  },

  computed: {
    isLocalEnv() {
      return process.env.NODE_ENV === 'local';
    },

    successImage() {
      return successImage;
    },

    getContainerName() {
      if (this.container === 'subscriptions') {
        return this.$t('globals.container.subscription')
      } else if (this.container === 'waitlistsubscriptions') {
        return this.$t('globals.container.waitlist')
      } else {
        return this.$t('globals.container.booked')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.align-content-center {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: relative;

  .success-block {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/payment/vipps/Success.vue